(function () {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7bbe"];
var parcelRegister = parcelRequire.register;
parcelRegister("3mB8X", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $8233f8e478702dff$export$2e2bcd8739ae039; });

var $a9eYm = parcelRequire("a9eYm");

var $N2wHE = parcelRequire("N2wHE");
parcelRequire("lLUSR");
const $8233f8e478702dff$var$ViewingItem = ({ viewing: viewing, whiteText: whiteText })=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($N2wHE))).locale("sv");
    return /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
        className: "flex flex-wrap items-center rounded-md md:w-1/2 lg:w-full pt-2 w-full mx-auto",
        children: [
            /*#__PURE__*/ (0, $a9eYm.jsxs)("p", {
                className: "flex my-0 justify-between w-full",
                children: [
                    /*#__PURE__*/ (0, $a9eYm.jsxs)("span", {
                        className: `${whiteText ? "text-white" : "text-blue700"} font-icb`,
                        children: [
                            (0, (/*@__PURE__*/$parcel$interopDefault($N2wHE)))(viewing.startTime).format("ddd").charAt(0).toUpperCase() + (0, (/*@__PURE__*/$parcel$interopDefault($N2wHE)))(viewing.startTime).format("dddd").slice(1),
                            " ",
                            (0, (/*@__PURE__*/$parcel$interopDefault($N2wHE)))(viewing.startTime).format("D"),
                            " ",
                            (0, (/*@__PURE__*/$parcel$interopDefault($N2wHE)))(viewing.startTime).format("MMMM"),
                            " "
                        ]
                    }),
                    /*#__PURE__*/ (0, $a9eYm.jsx)("span", {
                        children: (0, (/*@__PURE__*/$parcel$interopDefault($N2wHE)))(viewing.startTime).format("HH:mm") !== "00:00" && /*#__PURE__*/ (0, $a9eYm.jsxs)("span", {
                            className: `${whiteText ? "text-white" : "text-blue700"} font-icb`,
                            children: [
                                (0, (/*@__PURE__*/$parcel$interopDefault($N2wHE)))(viewing.startTime).format("HH:mm"),
                                "-",
                                (0, (/*@__PURE__*/$parcel$interopDefault($N2wHE)))(viewing.endTime).format("HH:mm") !== "00:00" && /*#__PURE__*/ (0, $a9eYm.jsx)("span", {
                                    children: (0, (/*@__PURE__*/$parcel$interopDefault($N2wHE)))(viewing.endTime).format("HH:mm")
                                })
                            ]
                        })
                    })
                ]
            }),
            viewing.commentary && !viewing.fullyBooked && new Date(viewing.noLaterThen) > new Date() ? /*#__PURE__*/ (0, $a9eYm.jsx)("p", {
                className: `${whiteText ? "text-white" : "text-black500"} my-0 text-tiny leading-4 w-full`,
                children: viewing.commentary
            }) : new Date(viewing.noLaterThen) < new Date() && !viewing.fullyBooked && /*#__PURE__*/ (0, $a9eYm.jsx)("p", {
                className: `${whiteText ? "text-white" : "text-black500"} my-0 text-tiny leading-4 w-full`,
                children: "Bokning st\xe4ngd"
            }),
            viewing.fullyBooked && /*#__PURE__*/ (0, $a9eYm.jsx)("p", {
                className: `${whiteText ? "text-white" : "text-black500"} my-0 text-tiny leading-4 w-full`,
                children: "Fullbokad"
            })
        ]
    });
};
var $8233f8e478702dff$export$2e2bcd8739ae039 = $8233f8e478702dff$var$ViewingItem;

});

})();
//# sourceMappingURL=ViewingItem.2d8252ab.js.map
